// import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_SHOP_FAIL = "SHOP:GET_SHOP_FAIL";

export const getShopFailAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_SHOP_FAIL as typeof GET_SHOP_FAIL,
  organization,
  id,
});

export type GetShopFailAction = ReturnType<typeof getShopFailAction>;
